import { addClasses, removeClasses, toggleClass } from './DOMHelpers';
import { IFrameHelper } from './IFrameHelper';
import { isExpandedView } from './settingsHelper';

export const bubbleSVG = [
  'M1673.63 145.358L1253.83 1263.07C1230.4 1325.27 1156.48 1351.49 1099.02 1318.02L762.896 1122.2L857.178 1107.14L1016.17 1200.03C1037.09 1212.3 1060.8 1218.44 1084.51 1218.44C1099.86 1218.44 1115.2 1215.93 1129.98 1210.63C1167.64 1197.24 1197.48 1167.95 1211.43 1130.57L1515.2 321.927C1533.88 272.276 1522.45 217.603 1485.35 179.389C1448.25 141.453 1393.86 128.622 1343.65 145.916L283.679 513.558C232.912 531.131 198.323 575.204 193.024 628.481C187.724 681.758 213.386 731.967 259.69 758.746L389.955 834.617L384.376 901.562L53.2751 708.537C-25.9436 662.233 -14.5071 544.241 72.243 514.116L1537.79 6.16748C1623.98 -23.679 1705.71 60.0027 1673.63 145.358Z',
  'M1363.1 200.592L302.577 568.233C239.816 589.991 231.448 675.346 288.909 708.819L450.694 803.1L424.753 1117.74L868.545 1046.61L1045.67 1149.82C1087.23 1174.09 1140.79 1155.12 1157.53 1109.93L1461.29 301.289C1484.44 239.922 1425.31 179.113 1363.1 200.592Z',
];

export const body = document.getElementsByTagName('body')[0];
export const widgetHolder = document.createElement('div');

export const bubbleHolder = document.createElement('div');
export const chatBubble = document.createElement('button');
export const closeBubble = document.createElement('button');
export const notificationBubble = document.createElement('span');

export const setBubbleText = bubbleText => {
  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.getElementById('omnigo-widget-expanded__text');
    textNode.innerText = bubbleText;
  }
};

export const createBubbleIcon = ({ className, path, target }) => {
  let bubbleClassName = `${className} omnigo-elements--${window.$chatwoot.position}`;
  const bubbleIcon = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'svg'
  );
  bubbleIcon.setAttributeNS(null, 'id', 'omnigo-widgetbubble-icon');
  bubbleIcon.setAttributeNS(null, 'width', '35');
  bubbleIcon.setAttributeNS(null, 'height', '35');
  bubbleIcon.setAttributeNS(null, 'viewBox', '0 0 1681 1333');
  bubbleIcon.setAttributeNS(null, 'fill', 'none');
  bubbleIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

  if (Array.isArray(path)) {
    const bubblePath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    bubblePath.setAttributeNS(null, 'd', path[0]);
    bubblePath.setAttributeNS(null, 'fill', '#000000');

    bubbleIcon.appendChild(bubblePath);

    const bubblePath2 = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    bubblePath2.setAttributeNS(null, 'd', path[1]);
    bubblePath2.setAttributeNS(null, 'fill', '#000000');

    bubbleIcon.appendChild(bubblePath2);
  } else {
    const bubblePath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    bubblePath.setAttributeNS(null, 'd', path);
    bubblePath.setAttributeNS(null, 'fill', '#000000');

    bubbleIcon.appendChild(bubblePath);
  }
  target.appendChild(bubbleIcon);

  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.createElement('div');
    textNode.id = 'omnigo-widget-expanded__text';
    textNode.innerText = '';
    target.appendChild(textNode);
    bubbleClassName += ' omnigo-widget-expanded';
  }

  target.className = bubbleClassName;
  target.title = 'Open chat window';
  return target;
};

export const createBubbleHolder = hideMessageBubble => {
  if (hideMessageBubble) {
    addClasses(bubbleHolder, 'woot-hidden');
  }
  addClasses(bubbleHolder, 'woot--bubble-holder');
  body.appendChild(bubbleHolder);
};

export const createNotificationBubble = () => {
  addClasses(notificationBubble, 'woot--notification');
  return notificationBubble;
};

export const onBubbleClick = (props = {}) => {
  const { toggleValue } = props;
  const { isOpen } = window.$chatwoot;
  if (isOpen !== toggleValue) {
    const newIsOpen = toggleValue === undefined ? !isOpen : toggleValue;
    window.$chatwoot.isOpen = newIsOpen;

    toggleClass(chatBubble, 'woot--hide');
    toggleClass(closeBubble, 'woot--hide');
    toggleClass(widgetHolder, 'woot--hide');
    IFrameHelper.events.onBubbleToggle(newIsOpen);

    if (!newIsOpen) {
      chatBubble.focus();
    }
  }
};

export const onClickChatBubble = () => {
  bubbleHolder.addEventListener('click', onBubbleClick);
};

export const addUnreadClass = () => {
  const holderEl = document.querySelector('.omnigo-widgetholder');
  addClasses(holderEl, 'has-unread-view');
};

export const removeUnreadClass = () => {
  const holderEl = document.querySelector('.omnigo-widgetholder');
  removeClasses(holderEl, 'has-unread-view');
};
